<script>
import ResourceDetail from '@shell/components/ResourceDetail';

export default {
  name:       'RolesResourcedId',
  components: { ResourceDetail },
};
</script>

<template>
  <ResourceDetail />
</template>
